<template>
	<nut-dialog
		teleport="body"
		title="通知"
		:visible="modelValue"
		ok-text="前往"
		:no-cancel-btn="!tip.cancellable"
		:no-ok-btn="!tip.redirect"
		@ok="handleOk"
		@cancel="hanldleClose"
	>
		<div v-if="tip.body" v-html="tip.body"></div>
	</nut-dialog>
</template>

<script>
import { homeRedirectMap } from '@/constants';
import useNavigate from '@/hooks/useNavigate';
export default {
	name: 'NoticeModal',
	props: {
		modelValue: {
			type: Boolean,
			required: true,
		},
		tip: {
			type: Object,
			required: true,
		},
	},
	emits: ['update:modelValue'],
	setup(props, { emit }) {
		const { push } = useNavigate();
		const hanldleClose = () => {
			emit('update:modelValue', false);
		};

		const handleOk = () => {
			if (props.tip.redirect) {
				push(homeRedirectMap[props.tip.type]);
			}
		};
		return {
			hanldleClose,
			handleOk,
		};
	},
};
</script>

<style lang="scss" scoped>
.row {
	@include flex-center;
	line-height: 28px;
	font-size: $normal-font-size;

	.val-off {
		color: $error-color;
	}
}
</style>
